import BASE_URL from "../../shared/base-url"

export const PARKING_LOT_ENDPOINT = {
  detail: `${BASE_URL}/parking-lots/get-parking`,
  list: `${BASE_URL}/parking-lots/get-parkings`,

  // getOwnersOfSale: `${BASE_URL}/owners/get-owners`,
  archive: `${BASE_URL}/parking-lots/archive-parking`,
  delete: `${BASE_URL}/parking-lots/delete-parking`,
  toggleStatus: `${BASE_URL}/parking-lots/activate-or-block-parking`,
  restore: `${BASE_URL}/parking-lots/restore-parking`,
  archivedParkingLots: `${BASE_URL}/parking-lots/get-archived-parking-lots`,
  archivedParking: `${BASE_URL}/parking-lots/get-archived-parkings`,
  create: `${BASE_URL}/parking-lots/create-parking`,
  update: `${BASE_URL}/parking-lots/update-parking`,
  calculateActivityPrice: `${BASE_URL}/parking-lots/calculate-activity-price`,





  export: `${BASE_URL}/parking-lots/export-parking-lots`,
  import: `${BASE_URL}/parking-lots/import-parking-lots`,
  removeFile: `${BASE_URL}/parking-lots/remove-image`,
}
